var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-spinner-container",style:({height: _vm.height+'px'})},[_c('b-spinner',{staticStyle:{"color":"#19A39C"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }